import { StreamingBanner } from 'src/views/WatchLandingView/RecommendedBannerCarousel/RecommendedBanner/StreamingBanner'
import { HeroBannerData } from '@/services/RecommendedBannerService/types'
import { GenericBanner } from '@/views/WatchLandingView/RecommendedBannerCarousel/RecommendedBanner/GenericBanner'
import { TicketsBanner } from '@/views/WatchLandingView/RecommendedBannerCarousel/RecommendedBanner/TicketsBanner'

type RecommendedBannerProps = {
  banner: HeroBannerData
}

export const RecommendedBanner: React.FC<RecommendedBannerProps> = ({ banner }) => {
  if (banner.type === 'streaming') {
    return <StreamingBanner banner={banner} />
  }

  if (banner.type === 'tickets') {
    return <TicketsBanner banner={banner} />
  }

  if (banner.type === 'generic') {
    return <GenericBanner banner={banner} />
  }

  return null
}
